import { getCorrectDomain } from "../AppSettings";

interface IApiPostContact {
    name: string;
    email: string;
    message: string;
}

export const ApiPostContact = async ({ name, email, message }: IApiPostContact) => {
    return fetch(getCorrectDomain() + '/api/contact/add', {
        method: 'POST',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({
            name: name,
            email: email,
            message: message,
        })
    }).then(function (response) {        
        if (response.ok) {
            console.log("APIPOSTContact response: ", response);
            return response.json();
        }
        return Promise.reject(response);
    }).then(function (data) {
        console.log("Fetched contact response: " + JSON.stringify(data));
        return data[0];
    }).catch(function (error) {
        console.warn('Something went wrong.', error);
    });
}